<div>
    <div class="row">
        <div class="col-12 align-items-center justify-content-center mt-1">
            <h5 class="mb-0 game-text d-flex align-items-center">
                <span #metricText class="variation-ellipsis" 
                    [tooltip]="checkTextTruncation(game?.SelectedMetrics[0]?.abbrev, TooltipType.Q1)" placement="top" container="body" containerClass="tooltip-custom-milestone"
                    (mouseenter)="tooltip.show()" 
                    triggers="manual"
                    #tooltip="bs-tooltip"
                    (mouseleave)="tooltip.hide()"
                    (wheel)="tooltip.hide()">
                    {{game?.SelectedMetrics[0]?.abbrev}}:
                </span>
                <span class="ml-1 game-text-detail" *ngIf="gameStatus === 'Upcoming'">--</span>
                <span class="ml-1 game-text-detail" *ngIf="gameStatus !== 'Upcoming'">{{ranking?.gameRewards?.MyRankingObj?.MetricGroupInfos[0]?.MyMetricValue ?? "--"}}</span>
            </h5>
        </div>
    </div>
    <cxone-game-qualifier *ngIf="game.Qualifier !== null" [game]="game" [ranking]="ranking" [gameStatus]="gameStatus" [checkTextTruncation]="checkTextTruncation"></cxone-game-qualifier>
    <div class="d-flex progress-container">
        <div class="progress-step" [ngClass]="{'step-completed': isWinnerMilestone(j - 1 - i)}"
            *ngFor="let milestoneReward of milestoneRewards; index as i; count as j; last as isLast"
            [ngbPopover]="popoverProgressBar" (mouseenter)="tooltipMilestone.open()" (mouseleave)="tooltipMilestone.close()" (wheel)="tooltipMilestone.close()" placement="bottom" 
            popoverClass="cxone-milestone-tooltip" container="body" triggers="manual" #tooltipMilestone="ngbPopover">
            <ng-template #popoverProgressBar>
                <div class="d-flex flex-column">
                    <span class="popup-title">{{getLocalizationString("Milestone", "Milestone")}} {{i + 1}}</span>
                    <span class="tooltip-text">{{getTooltipMetric(i, j, isLast)}}</span>
                    <div class="d-flex reward-container align-items-center">
                        <span class="d-flex">
                            <svg class="icon-16">
                                <use href="../../../App_Themes/CXone/icons/gamification/games/coin-reward.svg#coin-reward"></use>
                            </svg>
                            <span class="tooltip-text ml-1">{{milestoneReward.coins | cvNumberLocalize}}</span>
                        </span>
                        <span class="d-flex badge align-items-center">
                            <svg class="icon-16">
                                <use href="../../../App_Themes/CXone/icons/gamification/games/badge-reward.svg#badge-reward"></use>
                            </svg>
                            <span>
                                <div class="ml-1" *ngIf="milestoneReward.badgeSrc">
                                    <img *ngIf="milestoneReward.badgeSrc; else doubleDash" [src]="milestoneReward.badgeSrc">
                                </div>
                                <ng-template #doubleDash>
                                    <span class="text-double-dash ml-2"> -- </span>
                                </ng-template>
                            </span>
                        </span>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>